import { type RouteRecordRaw } from 'vue-router'

export const brandStatusRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/BrandStatusOverviewView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'brand-status.overview',
        },
        name: 'brand.brand-status.overview',
        path: 'overview',
      },
      {
        component: async () => import('../views/GbpSupportDetailView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'brand-status.gbp-support',
        },
        name: 'brand.brand-status.gbp-support',
        path: 'gbp-support/:locationId',
      },
    ],
    component: {
      name: 'BrandStatusRouterView',
      template: '<router-view></router-view>',
    },
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
    },
    name: 'brand.brand-status',
    path: 'brand-status',
    redirect: { name: 'brand.brand-status.overview' },
  },
]
